<template>
  <View gap="sm" align="center">
    <RenterProfileLink :property-id="propertyId" :renter-id="renter.id" :decoration="false">
      <Avatar :userName="renter.user.name" :status="status" />
    </RenterProfileLink>

    <RenterProfileLink :property-id="propertyId" :renter-id="renter.id">
      <Text variant="label-small" as="span">{{ renter.user.name }}</Text>
    </RenterProfileLink>
  </View>
</template>

<script setup lang="ts">
import { Text, Avatar, View, AvatarStatus } from '@tallo/design-system';
import { RenterProfileLink } from '@tallo/investor/renter';
import { RenterDto } from '@tallo/renter';

defineProps<{ propertyId: string; renter: RenterDto; status: AvatarStatus }>();
</script>

<style scoped></style>
